import { MeetingDays } from "../../../common/dtos/classes.type";

export function parseDate(dateString: string): {
  weekday: string;
  date: number;
} {
  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));

  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const weekday = weekdays[date.getUTCDay()];
  const dateNumber = date.getUTCDate();

  return {
    weekday,
    date: dateNumber,
  };
}

interface Event {
  start_date: string;
  [key: string]: any;
}

interface MonthGroup {
  title: string;
  items: Event[];
}

export function groupEventsByMonth(events: Event[]): MonthGroup[] {
  const MONTH_NAMES = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const groupedEvents = events.reduce((grouped, event) => {
    const [year, month] = event.start_date.split("-").map(Number);
    const monthName = MONTH_NAMES[month - 1];
    const key = `${monthName}_${year}`;

    if (!grouped[key]) {
      grouped[key] = {
        title: `${monthName} ${year}`,
        monthName,
        year,
        items: [],
      };
    }

    grouped[key].items.push(event);
    return grouped;
  }, {} as Record<string, MonthGroup & { monthName: string; year: number }>);

  return Object.values(groupedEvents)
    .sort((a, b) => {
      if (a.year !== b.year) return a.year - b.year;
      return MONTH_NAMES.indexOf(a.monthName) - MONTH_NAMES.indexOf(b.monthName);
    })
    .map((group) => ({
      title: group.title,
      items: group.items.sort(
        (a, b) => a.start_date.localeCompare(b.start_date)
      ),
    }));
}

export function isMultipleDays(eventDays: MeetingDays): boolean {
  let trueCount = 0;

  for (const day in eventDays) {
    if (eventDays[day as keyof MeetingDays]) {
      trueCount++;
      if (trueCount > 1) {
        return true;
      }
    }
  }

  return false;
}
